export default __webpack_public_path__ + "static/media/01-Waqas-Nakhwa.048d0fab.png";